import { ChevronsUpDownIcon, LogOutIcon, Settings, UserCircle } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/shared/components/primitives/dropdown-menu";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/shared/components/primitives/sidebar";

import { TenkoAvatar } from "../data-display/TenkoAvatar";

export type TenkoNavUserProps = {
  user: {
    name: string;
    email: string;
    avatar?: string;
  };
  organization?: {
    name: string;
    avatar?: string;
  };
  accountLabel: string;
  settingsLabel: string;
  logoutLabel: string;
  organizationLabel: string;
  onAccount?: () => void;
  onSettings?: () => void;
  onLogout?: () => void;
};

export function TenkoNavUser({
  user,
  organization,
  accountLabel,
  settingsLabel,
  logoutLabel,
  organizationLabel,
  onAccount,
  onSettings,
  onLogout,
}: TenkoNavUserProps) {
  const { isMobile } = useSidebar();
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger render={<SidebarMenuButton size="lg" className="aria-expanded:bg-muted" />}>
            <TenkoAvatar name={user.name} alt={user.name} src={user.avatar}></TenkoAvatar>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">{user.name}</span>
              <span className="truncate text-xs">{user.email}</span>
            </div>
            <ChevronsUpDownIcon className="ml-auto size-4" />
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="min-w-56 rounded-lg"
            side={isMobile ? "bottom" : "right"}
            align="end"
            sideOffset={4}
          >
            {organization ? (
              <>
                <DropdownMenuGroup>
                  <DropdownMenuLabel className="p-0 font-normal">
                    <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                      <TenkoAvatar
                        shape="square"
                        name={organization.name}
                        alt={organization.name}
                        src={organization.avatar}
                      ></TenkoAvatar>
                      <div className="grid flex-1 text-left text-sm leading-tight">
                        <span className="truncate font-medium">{organization.name}</span>
                        <span className="truncate text-xs">{organizationLabel}</span>
                      </div>
                    </div>
                  </DropdownMenuLabel>
                </DropdownMenuGroup>
                <DropdownMenuSeparator />
              </>
            ) : null}
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={onAccount}>
                <UserCircle />
                {accountLabel}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onSettings}>
                <Settings />
                {settingsLabel}
              </DropdownMenuItem>
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={onLogout}>
              <LogOutIcon />
              {logoutLabel}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
